export function IncomeActions({
  styles,
  busy,
  msg,
  incomeJustFixed,
  onFix,
  onExtend,
}) {
  return (
    <div className={styles.incomeActions}>
      <button
        type='button'
        className={styles.incomeActions__btn}
        onClick={onFix}
        disabled={busy || incomeJustFixed}>
        {incomeJustFixed ? 'Зафиксировано' : 'Зафиксировать месяц'}
      </button>

      <div
        className={[
          styles.incomeActions__extend,
          incomeJustFixed ? styles['incomeActions__extend--disabled'] : '',
        ].join(' ')}>
        <button
          type='button'
          className={styles.incomeActions__plus}
          onClick={() => onExtend(10)}
          disabled={busy || incomeJustFixed}>
          +10%
        </button>

        <button
          type='button'
          className={styles.incomeActions__plus}
          onClick={() => onExtend(15)}
          disabled={busy || incomeJustFixed}>
          +15%
        </button>

        <button
          type='button'
          className={styles.incomeActions__plus}
          onClick={() => onExtend(20)}
          disabled={busy || incomeJustFixed}>
          +20%
        </button>
      </div>

      {msg ? <div className={styles.incomeActions__msg}>{msg}</div> : null}
    </div>
  );
}
